import { LoaderCircle } from 'lucide-react';
import { cn } from '@/shared/lib/cn';

const sizeClasses = {
  xs: 'size-3.5',
  sm: 'size-4',
  md: 'size-5',
  lg: 'size-8',
} as const;

export interface SpinnerProps {
  size?: keyof typeof sizeClasses;
  className?: string;
  /** Tekst dla czytnikow ekranu. Ustaw `null`, gdy obok jest juz widoczna etykieta. */
  label?: string | null;
}

/** Wskaznik trwajacej operacji. */
export function Spinner({ size = 'md', className, label = 'Ładowanie…' }: SpinnerProps) {
  return (
    <>
      <LoaderCircle
        aria-hidden="true"
        className={cn('animate-spin', sizeClasses[size], className)}
        strokeWidth={2.5}
      />
      {label !== null && <span className="sr-only">{label}</span>}
    </>
  );
}
